import * as CaseApi from 'saas/pco/cases/api';
import { createAction } from 'redux-actions';

export const fetchSitesAction = createAction('case.FETCH_SITES');
export const fetchSitesSuccessAction = createAction('case.FETCH_SITES_SUCCESS');
export const selectSiteAction = createAction('case.SELECT_SITE');
export const unselectSiteAction = createAction('case.UNSELECT_SITE');
export const refreshStudiesAction = createAction('case.REFRESH_STUDIES');

export const fetchSites = caseId => (dispatch, getState) => {
  const state = getState();
  if (state.sites.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchSitesAction());

  if (caseId) {
    return CaseApi.getSitesByCase(caseId).then(response =>
      dispatch(fetchSitesSuccessAction(response))
    );
  } else {
    return dispatch(fetchSitesSuccessAction([]));
  }
};

export const selectSite = site => (dispatch, getState) => {
  dispatch(selectSiteAction(site));
};

export const unselectSite = site => (dispatch, getState) => {
  dispatch(unselectSiteAction(site));
};

export const refreshStudies = caseId => (dispatch, getState) => {
  dispatch(refreshStudiesAction(caseId));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/actions/sites.js